import * as React from "react";
const SvgFiRrSquid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-squid_svg__a)">
      <path
        fill="#062147"
        d="M19 0h-5.822a4.24 4.24 0 0 0-3.022 1.252c-1.02 1.02-1.401 2.594-.997 4.108l.659 2.471c-.585.444-1.14.918-1.643 1.421L4.09 13.39c-.463.463-1.27.463-1.732 0a1.225 1.225 0 0 1 0-1.731l2.399-2.404a.999.999 0 1 0-1.416-1.412l-2.4 2.404a3.23 3.23 0 0 0 .004 4.558 3.23 3.23 0 0 0 4.259.264l1.18 1.181-3.124 3.125a.999.999 0 1 0 1.414 1.414L7.8 17.664l1.198 1.198a3.23 3.23 0 0 0 .316 4.194 3.21 3.21 0 0 0 2.28.942c.826 0 1.649-.312 2.277-.939l2.346-2.341a.999.999 0 1 0-1.412-1.416l-2.346 2.341a1.227 1.227 0 0 1-1.731 0 1.227 1.227 0 0 1 .006-1.738l4.02-4.083c.5-.501.975-1.054 1.417-1.638l2.47.659c.4.106.804.159 1.2.159 1.106 0 2.158-.405 2.909-1.156a4.25 4.25 0 0 0 1.252-3.022V5.002c0-2.757-2.243-5-5-5zm-5.668 14.412-2.955 3.002-3.748-3.748 2.965-3.004c2.476-2.476 6.492-4.245 8.405-4.684-.416 1.936-2.186 5.952-4.667 8.434M22 10.822c0 .607-.236 1.179-.666 1.608-.517.518-1.351.699-2.18.479l-1.795-.479c1.366-2.236 2.284-4.588 2.595-6.032a1.975 1.975 0 0 0-2.352-2.353c-1.444.311-3.796 1.229-6.033 2.595l-.48-1.796c-.22-.827-.036-1.662.48-2.179a2.26 2.26 0 0 1 1.608-.666h5.822c1.654 0 3 1.346 3 3v5.823"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-squid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquid;
